import React from 'react';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import style from './TooltipNew.module.scss';

interface IProps {
	children: React.ReactNode;
	title: string;
	placement?: TooltipPlacement;
}

export const TooltipForElementNew: React.FC<IProps> = React.memo(({ children, title, placement = 'topLeft' }) => (
	<Tooltip overlayClassName={style.container} title={title} placement={placement}>
		{children}
	</Tooltip>
));
